export default __webpack_public_path__ + "static/media/img-slider-tspace-6.a086287d.png";